export function applyBrandColors(colors: {
  background: string;
  text: string;
  icon: string;
  button: string;
  gral: string;
}) {
  const root = document.documentElement;

  root.style.setProperty('--brand-bg', colors.background);
  root.style.setProperty('--brand-text', colors.text);
  root.style.setProperty('--brand-icon', colors.icon);
  root.style.setProperty('--brand-button', colors.button);
  root.style.setProperty('--brand-gral', colors.gral);
}
